import { inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, catchError, map, of, switchMap, tap } from 'rxjs';

import { InsurancePackageService } from '@admin/core/services/insurance-package.service';
import { ClientPackageOption } from '@admin/src/core/models/client-create-ui-state.interface';
import {
  getClientPackagesOptions,
  getClientPackagesOptionsFailure,
  getClientPackagesOptionsSuccess,
  setClientCreateUiStep,
} from '@admin/store/client-create-ui/client-create-ui.actions';

import { InsurancePackage, PackageStatus } from '@lib/core/models/insurance-package.interface';

export const setClientCreateUiStepEffect = createEffect(
  (actions$ = inject(Actions)): Observable<Action> =>
    actions$.pipe(
      ofType(setClientCreateUiStep),
      tap(() => {
        // console.log('setClientCreateUiStepEffect');
      })
    ),
  { functional: true, dispatch: false }
);

export const getClientPackagesOptionsEffect = createEffect(
  (actions$ = inject(Actions), insurancePackageService = inject(InsurancePackageService)): Observable<Action> =>
    actions$.pipe(
      ofType(getClientPackagesOptions),
      switchMap(() =>
        insurancePackageService.getInsurancePackages().pipe(
          map((insurancePackages: InsurancePackage[]) => {
            const clientPackagesOptions: ClientPackageOption[] = insurancePackages
              .filter(insurancePackage => insurancePackage.status === PackageStatus.Active)
              .map(insurancePackage => ({
                id: insurancePackage.id,
                name: insurancePackage.name,
                clientType: insurancePackage.clientType,
              }));
            return getClientPackagesOptionsSuccess(clientPackagesOptions);
          }),
          catchError(() => of(getClientPackagesOptionsFailure({ error: 'Failed to fetch packages' })))
        )
      )
    ),
  {
    functional: true,
    dispatch: true,
  }
);
